import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import withStyles from '@mui/styles/withStyles';
import AchievementsContext from "../../contexts/achievements-context";

const styles = (theme) => ({
  lection: {
    backgroundColor: "#7FC5ED",
    color: "#fff",
    borderRadius: "0 0 0 60px",
    zIndex: -100,
  },
  heading: {
    fontSize: 16,
    fontWeight: 300,
    marginLeft: 40,
    marginTop: 30,
    marginBottom: 30,
  },
  creditContainer: {
    width: "100px",
    height: "100px",
    borderRadius: "20px",
    backgroundColor: "#fff",
    margin: "5px",
    marginBottom: "80px",
    color: "#238cb9",
    textAlign: "center",
    fontWeight: 700,
    fontSize: "18px",
  },
  creditInnerContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "5px",
  },
  achievedCredits: { fontSize: "26px", marginTop: "2px", marginBottom: 0 },
  achievedCreditsText: { fontSize: "14px", marginTop: "2px" },
});

const CourseCredits = ({ classes }) => {
  const { achievedPoints, spentPoints, availablePoints } = useContext(
    AchievementsContext
  );
  return (
    <div style={{ position: "relative" }}>
      <Box
        className={classes.lection}
        display="flex"
        width="100%"
        flexDirection="column"
        justifyContent="flex-end"
      >
        <Typography variant="body1" className={classes.heading}>
          Punkteübersicht
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            marginLeft: "20px",
          }}
        >
          <div className={classes.creditContainer}>
            <div className={classes.creditInnerContainer}>
              <p className={classes.achievedCredits}>{achievedPoints}</p>
              <p className={classes.achievedCreditsText}>erreicht</p>
            </div>
          </div>

          <div className={classes.creditContainer}>
            <div className={classes.creditInnerContainer}>
              <p className={classes.achievedCredits}>{spentPoints}</p>
              <p className={classes.achievedCreditsText}>eingelöst</p>
            </div>
          </div>

          <div className={classes.creditContainer}>
            <div className={classes.creditInnerContainer}>
              <p className={classes.achievedCredits}>{availablePoints} </p>
              <p className={classes.achievedCreditsText}>verfügbar</p>
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default withStyles(styles)(CourseCredits);
